export enum VendorFields {
    vendorInn = "vendorInn",
    vendor = "vendor",
    vendorEngName = "vendorEngName",
    vendorKpp = "vendorKpp",
    vendorAddress = "vendorAddress",
    vendorSite = "vendorSite",
    vendorBankName = "vendorBankName",
    vendorBic = "vendorBic",
    vendorPaymentAccount = "vendorPaymentAccount",
    vendorCorrAccount = "vendorCorrAccount"
}
